import {createRoot} from "react-dom/client";
import Index from "./routes/_index";
import {NonRemixApp} from "./root";

const container = document.getElementById("app");
const root = createRoot(container)
root.render(<NonRemixApp>
    <Index/>
</NonRemixApp>);
